import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/Buttons/button";
import BasicModal from "../../../../models/models";
import {
  getUserDetails,
  selectUser,
} from "../../../../../redux/slices/userSlice";

const Account = () => {
  const dispatch = useDispatch();
  const State = useSelector(selectUser);
  const { userDetails } = State;
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const user_id = userDetails?.user?.id

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  const handleResetPassword = () => {
    setPopup(true);
    setState(63)
  }

  return (
    <div className="p-3 md:p-6 lg:p-8 flex flex-col gap-3 md:gap-6 lg:gap-8">
      <p className="text-2xl font-bold text-white">Account</p>
      <div className="rounded-[12px] md:rounded-[24px] lg:rounded-[32px] border border-solid border-[#596073] p-3 md:p-4 lg:p-6 flex flex-col gap-3 md:gap-4">
        <div>
          <p className="text-sm font-bold text-white">Display name</p>
          <span className="text-sm font-normal text-white">
            {userDetails?.user?.name}
          </span>
        </div>
      </div>
      <div className="rounded-[12px] md:rounded-[24px] lg:rounded-[32px] border border-solid border-[#596073] p-3 md:p-4 lg:p-6 flex flex-col gap-3 md:gap-4">
        <div>
          <p className="text-sm font-bold text-white">Email</p>
          <span className="text-sm font-normal text-white">
            {userDetails?.user?.email}
          </span>
        </div>        
      </div>
      <div className="rounded-[12px] md:rounded-[24px] lg:rounded-[32px] border border-solid border-[#596073] p-3 md:p-4 lg:p-6 flex flex-col gap-3 md:gap-4">
        <div>
          <p className="text-sm font-bold text-white">Thryft Role</p>
          <span className="text-sm font-normal text-white capitalize">
            {userDetails?.user?.role}
          </span>
        </div>        
      </div>
      <div 
        className="text-sm font-bold cursor-pointer pt-[10px] hover:text-[#ffe766]"
        onClick={handleResetPassword}
      >
        Reset password
      </div>

      {popup && (
        <BasicModal
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
          userId={user_id}
        />
      )}
    </div>
  );
};

export default Account;
